// @author Rico
import Vue from "vue";
import Storage from "@/utils/storage";
import { validateAccount, captchas } from "@/api/account";
import { isEmail, isPhone } from "@/utils/is";
import {
  Form,
  FormItem,
  Input,
  Select,
  Option,
  Loading,
  Button,
  Message,
  Divider,
} from "apower-ui";

Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Select);
Vue.use(Button);
Vue.use(Divider);
Vue.use(Option);
Vue.use(Loading.directive);
Vue.prototype.$message = Message;

// 账户相关表单组件基础类
const baseForm = {
  data() {
    const telephoneValidator = (rule, value, callback) => {
      if (this.activeWay === "email") {
        callback();
      }
      if (!this.form.telephone) {
        callback(new Error(this.$t("Account.001221")));
      } else if (!this.form.country_code) {
        callback(new Error(this.$t("Account.001766")));
      } else if (!isPhone(this.form.telephone)) {
        callback(new Error(this.$t("Account.001765")));
      } else {
        callback();
      }
    };

    const emailValidator = (rule, value, callback) => {
      if (this.activeWay === "phone") {
        callback();
      }
      if (!this.form.email) {
        callback(new Error(this.$t("Account.001212")));
      } else if (!isEmail(this.form.email)) {
        callback(new Error(this.$t("Account.001756")));
      } else {
        callback();
      }
    };

    const passwordValidator = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("Account.001213")));
      } else if (value.length < 6 || value.length > 20) {
        callback(new Error(this.$t("Account.002145")));
      } else {
        callback();
      }
    };

    return {
      accountParent: null,
      action: null,
      areaCodes: [],
      scene: null,
      activeWay: null,
      emailTimeout: 0,
      phoneTimeout: 0,
      emailIntervalId: null,
      phoneIntervalId: null,
      timeoutWait: 60,
      errorMessage: null,
      emailValidator: null,
      telephoneValidator: null,
      passwordValidator: null,
      loading: false,
      termsUrl: null,
      privacyUrl: null,
      policyUrl: null,
      errorMap: null,
      rules: {
        account: [
          {
            required: true,
            message: this.$t("Account.001216"),
            trigger: "blur",
          },
        ],
        password: [{ validator: passwordValidator, trigger: "blur" }],
        telephone: [{ validator: telephoneValidator, trigger: "blur" }],
        email: [{ validator: emailValidator, trigger: "blur" }],
        captcha: [
          {
            required: true,
            message: this.$t("Account.001222"),
            trigger: "blur",
          },
        ],
      },
      lang: null,
      phoneInputted: false,
      emailInputted: false,
      captchaInputted: false,
      passwordInputted: false,
      accountInputted: false,
    };
  },

  mounted() {
    this.$refs.accountForm.resetFields();
    const areaCodes = Storage.get("areacodes");
    this.lang = document.documentElement.lang || "en";
    if (areaCodes) {
      this.areaCodes = areaCodes;
      this.form.country_code = this.areaCodes[0].key;
    }
  },

  methods: {
    async sendVcode() {
      if (
        (this.activeWay === "email" && this.emailTimeout) ||
        (this.activeWay === "phone" && this.phoneTimeout)
      ) {
        return;
      }

      if (this.activeWay === "email") {
        if (!this.form.email || !isEmail(this.form.email)) {
          this.$message({
            message: this.$t("Account.001217"),
            type: "error",
            duration: 2 * 1000,
          });
          return;
        }
      } else if (this.activeWay === "phone") {
        if (!this.form.telephone || !isPhone(this.form.telephone)) {
          this.$message({
            message: this.$t("Account.001217"),
            type: "error",
            duration: 2 * 1000,
          });
          return;
        }
      }

      let postData;
      const brandId = Storage.get("brandId");
      if (this.activeWay === "email") {
        postData = {
          email: this.form.email,
          language: this.lang,
          brand_id: brandId,
        };
      } else if (this.activeWay === "phone") {
        postData = {
          country_code: this.processCountryCode(this.form.country_code),
          telephone: this.form.telephone,
          language: this.lang,
          brand_id: brandId,
        };
      }
      // 注册和重设密码都需要先validate账号
      if (
        this.action === "register" ||
        this.action === "reset-password" ||
        this.action === "bind"
      ) {
        const result = await validateAccount(postData);
        if (this.action === "register") {
          if (this.activeWay === "email") {
            if (result.data.status === 2) {
              this.$message({
                message: this.$t("Account.001763"),
                type: "error",
                duration: 2 * 1000,
              });
              return;
            }
          } else if (this.activeWay === "phone") {
            if (result.data.status === 2) {
              this.$message({
                message: this.$t("Account.001769"),
                type: "error",
                duration: 2 * 1000,
              });
              return;
            }
          }
        } else if (this.action === "reset-password") {
          if (this.activeWay === "email") {
            if (result.data.status === 1) {
              // todo
              this.$message({
                message: this.$t("Account.001377"),
                type: "error",
                duration: 2 * 1000,
              });
              return;
            }
          } else if (this.activeWay === "phone") {
            if (result.data.status === 1) {
              // todo
              this.$message({
                message: this.$t("Account.001378"),
                type: "error",
                duration: 2 * 1000,
              });
              return;
            }
          }
        }
      }
      try {
        const { status } = await captchas(
          Object.assign({ scene: this.scene }, postData)
        );

        if (status === 200) {
          if (this.activeWay === "email") {
            this.emailTimeout = 60;
            this.emailIntervalId = setInterval(() => {
              this.emailTimeout -= 1;
              if (this.emailTimeout === 0) {
                clearInterval(this.emailIntervalId);
              }
            }, 1000);
          } else if (this.activeWay === "phone") {
            this.phoneTimeout = 60;
            this.phoneIntervalId = setInterval(() => {
              this.phoneTimeout -= 1;
              if (this.phoneTimeout === 0) {
                clearInterval(this.phoneIntervalId);
              }
            }, 1000);
          }
        } else {
          this.processError(status);
        }
      } catch (error) {
        this.processError(error.status);
      }
    },

    onSubmit() {
      this.$refs.accountForm.validate((valid) => {
        if (valid) {
          if (this.action === "password-login") {
            this.loading = true;
            this.$store
              .dispatch("LoginByUsername", {
                account: this.form.account,
                password: this.form.password,
                language: this.lang,
              })
              .then(() => {
                this.processSuccess();
              })
              .catch((error) => {
                this.processError(error);
              })
              .finally(() => {
                this.loading = false;
              });
          } else if (this.action === "register") {
            this.loading = true;
            this.$store
              .dispatch("Register", {
                telephone: this.form.telephone,
                country_code: this.processCountryCode(this.form.country_code),
                email: this.form.email,
                captcha: this.form.captcha,
                password: this.form.password,
                language: this.lang,
              })
              .then(() => {
                this.processSuccess();
              })
              .catch((error) => {
                this.processError(error);
              })
              .finally(() => {
                this.loading = false;
              });
          } else if (this.action === "password-free-login") {
            this.loading = true;
            this.$store
              .dispatch("PasswordLessLogin", {
                telephone: this.form.telephone,
                country_code: this.processCountryCode(this.form.country_code),
                email: this.form.email,
                captcha: this.form.captcha,
                language: this.lang,
              })
              .then(() => {
                this.processSuccess();
              })
              .catch((error) => {
                this.processError(error);
              })
              .finally(() => {
                this.loading = false;
              });
          } else if (this.action === "reset-password") {
            this.loading = true;
            this.$store
              .dispatch("ResetPassword", {
                telephone: this.form.telephone,
                country_code: this.processCountryCode(this.form.country_code),
                email: this.form.email,
                captcha: this.form.captcha,
                password: this.form.password,
                language: this.lang,
              })
              .then(() => {
                this.processSuccess();
              })
              .catch((error) => {
                this.processError(error);
              })
              .finally(() => {
                this.loading = false;
              });
          }
        }
      });
    },

    processSuccess() {
      const identityToken = Storage.get("identityToken");
      const userInfo = Storage.get("userInfo");
      // 登录成功后触发的事件
      this.$emit("onSuccess", {
        identityToken,
        userInfo,
      });
      this.$emit("on-php-success", {
        //兼用php小写
        identityToken,
        userInfo,
      });
    },

    processError(error) {
      let message;
      switch (error) {
        case -200:
          if (
            this.activeWay === "email" ||
            (this.form.account && isEmail(this.form.account))
          ) {
            message = this.$t("Account.001377", { 0: "", 1: "" });
          } else if (
            this.activeWay === "phone" ||
            (this.form.account && isPhone(this.form.account))
          ) {
            message = this.$t("Account.001378", { 0: "", 1: "" });
          } else {
            message = this.$t("Account.002144");
          }
          break;
        case -205:
          message = this.$t("Account.001220");
          break;
        case -214:
          message = this.$t("Account.002135");
          break;
        case -206:
          if (
            this.activeWay === "email" ||
            (this.form.account && isEmail(this.form.account))
          ) {
            message = this.$t("Account.001231");
          } else if (
            this.activeWay === "phone" ||
            (this.form.account && isPhone(this.form.account))
          ) {
            message = this.$t("Account.001230", { 0: "", 1: "" });
          }
          break;
        case -303:
          message = this.$t("Account.001223");
          break;
        case -305:
          message = this.$t("Account.002136");
          break;
        case -307:
          message = this.$t("Account.002137");
          break;
        case 400:
          message = this.$t("Account.002138");
          break;
        case 401:
          message = this.$t("Account.002140");
          break;
        case 403:
          message = this.$t("Account.002141");
          break;
        case -9999:
          // 前端自定义未知错误 -9999
          message = this.$t("Account.001215");
          break;
        default:
          message = this.$t("Account.001215");
      }
      this.$message({
        message: message,
        type: "error",
        duration: 3 * 1000,
      });
    },

    processCountryCode(countryCode) {
      return countryCode.split(":")[0];
    },

    // 获取Account根组件
    getAccountParent() {
      let parent = this.$parent;
      while (parent) {
        if (parent.$options.componentName !== "Account") {
          parent = parent.$parent;
        } else {
          this.accountParent = parent;
          return true;
        }
      }
      return false;
    },

    setLoginWay(way) {
      this.activeWay = way;
      this.$refs.accountForm.$children[0].resetField();
    },

    goto(route) {
      this.$emit("goto", route);
    },

    onInput(type, ev) {
      switch (type) {
        case "phone":
          this.phoneInputted = ev ? true : false;
          break;
        case "email":
          this.emailInputted = ev ? true : false;
          break;
        case "account":
          this.accountInputted = ev ? true : false;
          break;
        case "captcha":
          this.captchaInputted = ev ? true : false;
          break;
        case "password":
          this.passwordInputted = ev ? true : false;
          break;
      }
    },
  },
};

export default baseForm;
